import { useState, useEffect } from 'react';

export interface TimeData {
  hours: number;
  minutes: number;
  seconds: number;
  timeString: string;
  date: Date;
}

/**
 * 실시간 시간 데이터를 제공하는 커스텀 훅
 * 매초마다 업데이트되는 시간 정보를 반환합니다.
 */
export const useTime = (): TimeData => {
  const [time, setTime] = useState<TimeData>(() => {
    const now = new Date();
    return {
      hours: now.getHours(),
      minutes: now.getMinutes(),
      seconds: now.getSeconds(),
      timeString: now.toLocaleTimeString('ko-KR', { 
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }),
      date: now
    };
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      setTime({
        hours: now.getHours(),
        minutes: now.getMinutes(),
        seconds: now.getSeconds(),
        timeString: now.toLocaleTimeString('ko-KR', { 
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }),
        date: now
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return time;
};
